import { render, staticRenderFns } from "./QuizGroupPreview.vue?vue&type=template&id=b9797090&scoped=true&"
import script from "./QuizGroupPreview.vue?vue&type=script&lang=ts&"
export * from "./QuizGroupPreview.vue?vue&type=script&lang=ts&"
import style0 from "./QuizGroupPreview.vue?vue&type=style&index=0&id=b9797090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9797090",
  null
  
)

export default component.exports